import { combineReducers } from 'redux';

import roundPlayReducer from './reducers/roundPlayReducer';
import screenReducer from './reducers/screenReducer';
import sessionReducer from './reducers/sessionReducer';
import liveChat from './reducers/liveChatReducer';
import standardItemReducer from './reducers/standardItemReducer';
import directMessage from './reducers/directMessageReducer';
import VOReducer from './reducers/VOReducer';
import saveDataReducer from './reducers/saveDataReducer';

// keeping the reducer collection as a separate exported object enables us
// to do some light test automation on every reducer.
// see ./reducers/__tests__/reducerRejections.test.js
// for more details.
export const reducerCollection = {
  screen: screenReducer,
  roundPlay: roundPlayReducer,
  session: sessionReducer,
  liveChat,
  directMessage,
  standardItem: standardItemReducer,
  VO: VOReducer,
  saveData: saveDataReducer,
};

const reducers = combineReducers({ ...reducerCollection });

export default reducers;
